import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UseTranslation from '../../../../../hooks/UseTranslation'
import { ReactComponent as PaperPlane } from '../../../../../images/PaperPlane.svg'
import ActionNotificationFormModal from '../../../../../pages/Notification/helper/ActionNotificationFormModal'
import NotificationsCard from '../NotificationsCard'
import NoDataFound from '../../../../PageHelpers/NoDataFound'
import {
  getNotificationsInboxBell,
  notificationInboxResetAlertHandler,
} from '../../../../../redux/features/notifications/notificationInbox/notificationInboxThunk'
import LoaderWithErrorHandler from '../../../../PageHelpers/LoaderWithErrorHandler'
import { selectNotificationInbox } from '../../../../../redux/features/notifications/notificationInbox/notificationInboxSlice'
import InboxBellSkeleton from './InboxBellSkeleton'

const InboxBellCard = () => {
  const notificationInboxStore = useSelector(selectNotificationInbox)

  const { t } = UseTranslation()
  const [notificationModalStatus, setNotificationModalStatus] = useState({
    status: false,
    type: null,
  })
  const [notificationModelData, setNotificationModelData] = useState()
  const dispatch = useDispatch()

  const handleNotificationModal = (type, data) => {
    setNotificationModalStatus({
      status: true,
      type,
    })
    setNotificationModelData(data)
  }

  const closePopupAndNavigate = (event, url) => {
    event.preventDefault();
    window.location.href = url
  }
  const renderNoDataFound = (store) => {
    if (store.loading.fetch !== true &&
      Object.values(store?.notificationsBell).every((arr) => !arr?.length)) {
      return <NoDataFound customStyle={styles.noDataFound} />
    }
    return null
  }
  useEffect(() => {
    dispatch(getNotificationsInboxBell())
  }, [])
  return (
    <Box>
      <Box
        component="a"
        href="/notifications/inbox"
        rel="noopener noreferrer"
        onClick={(event) => closePopupAndNavigate(event, '/notifications/inbox')}
        style={styles.showAllLink}
      >
        <Typography sx={styles.showAllText}>
          {t?.['Show all']}
        </Typography>
      </Box>

      <Box sx={styles.notificationCardList} data-testid="notification_Inbox_Container">
        {['today', 'yesterday', 'earlier'].map((timeframe) => (
          notificationInboxStore?.notificationsBell?.[timeframe]?.length > 0 && (
            <Box key={timeframe}>
              <Typography sx={styles.notificationTitle}>
                {t?.[timeframe]}
              </Typography>
              {notificationInboxStore?.notificationsBell?.[timeframe]?.map(
                (singleNotification, index) => (
                <NotificationsCard
                  key={singleNotification?.id}
                  notification={singleNotification}
                  icon={<PaperPlane />}
                  title={timeframe}
                  onApprove={(notification) => handleNotificationModal('approve', notification)}
                  onReject={(notification) => handleNotificationModal('reject', notification)}
                  customAnimation={index}
                />
                ),
              )}
            </Box>
          )
        ))}
      </Box>
      <LoaderWithErrorHandler store={notificationInboxStore}
        resetAlertHandler={notificationInboxResetAlertHandler}
        Skeleton={InboxBellSkeleton} />
      {renderNoDataFound(notificationInboxStore)}
      <ActionNotificationFormModal
        modalStatus={notificationModalStatus}
        setModalStatus={setNotificationModalStatus}
        data={notificationModelData}
        actionAfterSuccess={() => dispatch(getNotificationsInboxBell())}
      />

    </Box>
  )
}
const styles = {
  notificationTitle: {
    color: 'text.disabled',
    fontFamily: 'Avenir',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
  },
  showAllLink: {
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'end',
    margin: '10px 0px 0px',
  },
  showAllText: {
    fontSize: { xs: '13px', sm: '14px' },
    fontWeight: '500',
    cursor: 'pointer',
    color: '#29cc8b !important',
  },
  notificationCardList: {
    maxHeight: { xs: '400px', sm: '390px' },
    overflowY: 'scroll',
    '::-webkit-scrollbar': {
      width: '0.3em',
    },
    '::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: 'primary.main',
    },
  },
  noDataFound: {
    paddingTop: { xs: '30px', sm: '50px' },
    '& img': {
      width: { xs: '200px', sm: '350px' },
      height: { xs: '220px', sm: '310px' },
    },
  },
}

export default InboxBellCard
